import { auditConstants } from '../_constants/audit.constants'
import { alertConstants } from '../_constants/alert.constants'

const initialState = {
  isLoading: false,
  auditList: [],
  error: null,
  isGetAllError: false,
  count: 0,
  auditInfo: '',
  activeData: {},
}
export function audits(state = { ...initialState }, action) {
  state = {
    ...state,
    auditInfo:'',
  }
  switch (action.type) {
  case alertConstants.CLEAR:
    return {
      ...state,
      activeData: {},
      auditInfo: null,
      maptoolxMessage:null,
      backOfficeMessage:null
    }
  case auditConstants.GETALL_PAGE_REQUEST:
    return {
      ...state,
      isLoading: true,
      addUserMessage: null
    }
  case auditConstants.GETALL_PAGE_FAILURE:
    return {
      ...state,
      error: action.error,
      isLoading: false,
      auditList: [],
      count: 0,
      isGetAllError: true,
      addUserMessage: null
    }
  case auditConstants.GETALL_PAGE_SUCCESS:
    return {
      ...state,
      error: action.error,
      isLoading: false,
      addUserMessage: null,
      auditList: action.audits.data,
      count: action.audits.count
    }

  case auditConstants.GETBYID_SUCCESS:
    return {
      ...state,
      auditInfo: action.user.data,
      isLoading: false,
    }
  case auditConstants.GETBYID_FAILURE:
    return {
      ...state,
      error: action.error,
      isLoading: false,
    }
  case auditConstants.GETBYID_REQUEST:
    return {
      ...state,
      auditInfo: action.audit,
      isLoading: true,
      addUserMessage: null
    }

  default:
    return state
  }
}
